import xml from "csi/xml";

const {
	OP_CONTAINS,
	OP_EQUALS,
	OP_GREATER_EQUAL,
	OP_GREATER_THAN,
	OP_MATCHES,
	OP_NOT_CONTAINS,
	OP_NOT_EQUALS,
	OP_NOT_MATCHES,
	OP_LESS_EQUAL,
	OP_LESS_THAN,
	OP_BLANKS,
	OP_NON_BLANKS,
	OP_BLANK_DEFAULT,
	OP_BLANK_ENUM,
	OP_BLANK_LOCALIZED,
	OP_BLANK_TIME,
	OP_NULL,
	OP_NOT_NULL,
} = xml;

/** true represents we convert it to a not blank operator and false represents we convert it to a blank operator */
const convertToNotBlankOperatorMap: Record<string, boolean> = {
	CO: false,
	EQ: false,
	GE: false,
	GT: false,
	RE: false,
	NC: true,
	NE: true,
	NM: true,
	LE: false,
	LT: false,
};

/** Blank / Not Blank Operators */
const blankOperators = new Set([
	OP_BLANKS + OP_BLANK_DEFAULT,
	OP_NON_BLANKS + OP_BLANK_DEFAULT,
	OP_BLANKS + OP_BLANK_ENUM,
	OP_NON_BLANKS + OP_BLANK_ENUM,
	OP_BLANKS + OP_BLANK_LOCALIZED,
	OP_NON_BLANKS + OP_BLANK_LOCALIZED,
	OP_BLANKS + OP_BLANK_TIME,
	OP_NON_BLANKS + OP_BLANK_TIME,
	OP_NULL,
	OP_NOT_NULL,
]);

/**  get the operator for 0...many relationship */
export function getOpForMultiPath(operator: string): string {
	let op = operator;

	if (op === OP_EQUALS) {
		op = OP_CONTAINS;
	} else if (op === OP_NOT_EQUALS) {
		op = OP_NOT_CONTAINS;
	}

	return op;
}

/** return opposite operator than given operator if requires use of surrounding NOT condition */
export function getReverseOpToNegate(op: string): string | null {
	if (op === OP_NOT_CONTAINS) {
		return OP_EQUALS;
	} else if (op === OP_NOT_MATCHES) {
		return OP_MATCHES;
	}

	return null;
}

/** return the opposite operator for looking up violations */
export function getReverseOp(op: string): string | null {
	let operator = null;

	switch (op) {
		case OP_EQUALS:
			operator = OP_NOT_EQUALS;
			break;
		case OP_NOT_EQUALS:
			operator = OP_EQUALS;
			break;
		case OP_GREATER_EQUAL:
			operator = OP_LESS_THAN;
			break;
		case OP_LESS_THAN:
			operator = OP_GREATER_EQUAL;
			break;
		case OP_LESS_EQUAL:
			operator = OP_GREATER_THAN;
			break;
		case OP_GREATER_THAN:
			operator = OP_LESS_EQUAL;
			break;
		case OP_CONTAINS:
			operator = OP_NOT_CONTAINS;
			break;
		case OP_NOT_CONTAINS:
			operator = OP_CONTAINS;
			break;
		case OP_NOT_MATCHES:
			operator = OP_MATCHES;
			break;
		case OP_MATCHES:
			operator = OP_NOT_MATCHES;
			break;
		// TO DO - Need to handle Operator - "between" when the Date Range Picker component is in place
		default:
			operator = null;
			break;
	}

	return operator;
}

/** 
 * determine whether the operator should be is blank or is not blank if filter value is empty 
 * false = blank, true = is not blank
*/
export function isNotBlankOperator(operator: string): boolean {
	return convertToNotBlankOperatorMap[operator];
}

/** check if the operator is a blank / not blank operator */
export function isBlankOperator(op: string): boolean {
	return blankOperators.has(op);
}